export function getIndexColor(index: number) {
  switch (index % 4) {
    case 0:
      return '#0414A2';
    case 1:
      return '#3169F6';
    case 2:
      return '#83A5FA';
    case 3:
    default:
      return '#C1D2FC';
  }
}
